import React, { useState } from "react";
import { DxButton, DxToggle } from "genesys-react-components";
import { GenesysDevIcons } from "genesys-dev-icons";
import { Org } from "./Org";
import "../App.css";
import { DivisionFilter } from "./DivisionFilter";
import { ObjectSearch } from "./ObjectSearch";

export function LeftPanel({
  darkThemeEnabled,
  setDarkThemeEnabled,
  divisions,
  checkedDivisions,
  setCheckedDivisions,
  setSearchQueues,
  setSearchWrapupCodes,
  setOrg,
}) {
  const [tempCheckedDivisions, setTempCheckedDivisions] = useState(
    checkedDivisions
  ); // Temporary state for selected divisions
  const [queueValue, setQueueValue] = useState("");
  const [wrapupCodeValue, setWrapupCodeValue] = useState("");

  const handleApply = () => {
    setCheckedDivisions(tempCheckedDivisions); // Apply changes to the main state
    setSearchQueues(queueValue);
    setSearchWrapupCodes(wrapupCodeValue);
  };


  return (
    <div className="left-panel">
      <DxToggle
        className="theme-toggle"
        value={darkThemeEnabled}
        falseIcon={GenesysDevIcons.AppSun}
        trueIcon={GenesysDevIcons.AppMoon}
        onChange={(value) => setDarkThemeEnabled(value === true)}
      />
      <Org 
        setOrg={setOrg}
      />
      <DivisionFilter
        divisions={divisions}
        checkedDivisions={checkedDivisions}
        setTempCheckedDivisions={setTempCheckedDivisions} // Pass the setter for temporary state
      />
      <ObjectSearch 
        queueValue={queueValue}
        setQueueValue={setQueueValue}
        wrapupCodeValue={wrapupCodeValue}
        setWrapupCodeValue={setWrapupCodeValue}
      />
      <DxButton
        type="primary"
        className="apply-button"
        onClick={handleApply}
      >
        Apply
      </DxButton>
    </div>
  );
}